module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'earn-money-sticker': !_vm.$store.state.player.isPlaying,
      'earn-money-sticker--play': _vm.$store.state.player.isPlaying,
    }
  }, [_c('h3', [_vm._v("Every user can earn money.")]), _vm._v(" "), _c('p', [_vm._v("Setup your account now!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.learnMore()
      }
    }
  }, [_vm._v("Learn more")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a3fd010","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/earn_money.vue
// module id = 1808
// module chunks = 180